<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<video controls *ngIf="data.mediaType === 'video' && source" class="trafficVideo" style="width: 100%">
  <source type="video/webm" [src]="source">
</video>

<div *ngIf="data.mediaType === 'image' && source">
  <img *ngFor="let img of source" [src]="'data:image/png;base64,' + img.Images" style="width: 100%">
</div>
